import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { ListDefine } from "../../../Components/ThirdPartyList/ThirdPartyComponent";
import List from "../../../Components/List/List";
import { NavObjectType, ProvincesShortCode, lddGlobalSessionInfo } from "../../../Components/navigationTypes";
import { DRListItem, getDRMessageStatus, otherDateText } from "./DRlistFuncs";
import { Badge, BadgeProps, Button } from "react-bootstrap";
import moment from "moment";
import { NavigationContext } from "../../../Context/NavigationContext";
import { IAdSearchValue } from "../../../Components/fileList/fileList";
import { setInboxState } from "../../../redux/reducer";
import { useDispatch } from "react-redux";
import DRFilterBox, { DRFilterProps } from "./DRFilterBox";
import { runInnerFunction, runInnerFunction2 } from "../../../compatManager";
import { drRemoveLLCMsg } from "../drRequests";
import { LLCFuncs } from "../../LLCFuncs";
import { getLinkedRWFile } from "../../../Components/Notifications/notificationsFuncs";
import { debounce } from "../../../lib/debounce";
import { importDealCode, DRListModalType } from "../drFuncs";
import DealCodeModal from "../../../Components/BuilderConnect/DealCodeModal";

type FileListColumn = {
    attrName: string;
    dataType: string;
    width: string;
    title: string;
}


export const DRList = (listProps: {ModalType?: DRListModalType}) => {
    const listDef = ListDefine["DRFileList"].Sublists;
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const livedataRoot: Element = useAppSelector((state) => state.currentNavigation.livedataRootContainer?.dataRoot);
    const nav = useContext(NavigationContext);
    const dispatch = useDispatch();
    const searchRef = useRef<{staticSearch: () => void, reloadData: () => void}>();
    const [Filter, setFilter] = useState<DRFilterProps>({
        Types: [],
        MortgageStatuses: [],
        Status: false,
        Lawyer: ""});
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const [listColumns] = useState<FileListColumn[]>(
        [
            {
                attrName: "ProjectName",
                dataType: '',
                width: '34%',
                title: 'From'
            },
            {
                attrName: "OtherSideType",
                dataType: '',
                width: '6%',
                title: 'Type'
            },
            {
                attrName: "AvailableDate",
                dataType: '',
                width: '10%',
                title: 'Received'
            },
            {
                attrName: "ClientName",
                dataType: '',
                width: '40%',
                title: 'Client'
            },
            {
                attrName: "ClosingDate",
                dataType: '',
                width: '10%',
                title: 'Closing'
            },
            {
                attrName: "Status",
                dataType: '',
                width: '6%',
                title: "Status"
            }
        ]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [showDealCodeModal, setShowDealCodeModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        triggerStaticSearch();
    }, [Filter])

    const handleLoadFileData = (firmId: number, prov: ProvincesShortCode, sid: string, _filePage: number, _searchText: string, _adSearch: IAdSearchValue, _setADSearch: any, _sortedColumn?: string, _sortingOrder?: boolean): Promise<Response>[] => {
        let date = otherDateText(new Date(), 700);
        let listType = "0";
        if (listProps.ModalType == "inbox") listType = "1";
        if (listProps.ModalType == "mortgage") listType = "2";
        if (listProps.ModalType == "infile") listType = "3";
        const response = fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${prov}/${firmId}/${sessionInfo.user.account}/inbox?Time=${date}&SessionID=${sid}&type=${listType}`);
        return [response];
    }

    const triggerStaticSearch = () => {
        if (searchRef.current) {
            searchRef.current.staticSearch();
        }
    }

    function staticSearch(data: any[], searchText: string) {
        let filteredData = data;
        // search in ProjectName and ClientName, do client-side filtering & sort
        if (searchText > "") {
            filteredData = filteredData.filter((entry: DRListItem) => {
                return entry.ProjectName?.toLowerCase().includes(searchText) || entry.ClientName?.toLowerCase().includes(searchText);
            });
        }
        if (Filter.Types.length) { // Lender|Builder|LLC
            filteredData = filteredData.filter((entry: DRListItem) => {
                return Filter.Types.includes(entry.OtherSideType);
            });
        }
        if (Filter.Status) { // Read Status
            filteredData = filteredData.filter((entry: DRListItem) => {
                return entry.Status == 0 || entry.Status == 2;
            })
        }
        if (Filter.Lawyer) { // LSUCID
            filteredData = filteredData.filter((entry: DRListItem) => {
                return entry.LawyerID == Filter.Lawyer;
            })
        }
        if (Filter.MortgageStatuses.length) { // Mortgage Status
            filteredData = filteredData.filter((entry: DRListItem) => {
                return Filter.MortgageStatuses.includes(getDRMessageStatus(entry));
            })
        }

        return filteredData;
    }

    function buildSearchFilters() {
        return <DRFilterBox filter={Filter} setFilter={setFilter} setShowFilters={setShowFilters} modalType={listProps.ModalType} />
    }

    function buildButtonRight() {
        if (listProps.ModalType === "inbox" || listProps.ModalType === "mortgage") {
            return (
                <Button 
                    variant="primary" 
                    onClick={async () => {
                        setIsLoading(true);
                        try {
                            const data = await LLCFuncs.getLLCNewDeals(sessionInfo.sid);
                            console.log(data);
                            if (searchRef.current) {
                                searchRef.current.reloadData();
                            }
                        } finally {
                            setIsLoading(false);
                        }
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                        "Refresh LLC"
                    )}
                </Button>
            );
        }
        if (!listProps.ModalType) {
            return <Button variant="primary" onClick={() => setShowDealCodeModal(true)}>Enter Deal Code</Button>
        }
        return null;
    }

    function buildDRListLink(
        cols, searchText
    ) {
        return (drEntry: DRListItem) => {
            return (
                <DRListLink
                    entry ={drEntry}
                    key={drEntry.MsgID}
                    searchText={searchText}
                />
            )
        }
    }

    type DRLinkType = {
        entry: DRListItem,
        searchText: string,
    }

    function dateStr(timeStr: string): string {
        return moment(timeStr).format('DD/MMM/YYYY').toUpperCase();
    }

    function getHighlightedText(text: string, highlight: string) {
        // Split on highlight term and include term into parts, ignore case
        const highlightText = highlight;
        if (text) {
            highlight = highlight.replace(/\\/g, "");
            highlight = highlight.replace(/\*/g, "\\*");
            highlight = highlight.replace(/\+/g, "\\+");
            highlight = highlight.replace(/\./g, "\\.");
            highlight = highlight.replace(/\?/g, "\\?");
            highlight = highlight.replace(/\[/g, "\\[");
            highlight = highlight.replace(/\]/g, "\\]");
            highlight = highlight.replace(/\{/g, "\\{");
            highlight = highlight.replace(/\}/g, "\\}");
            highlight = highlight.replace(/\(/g, "\\(");
            highlight = highlight.replace(/\)/g, "\\)");
            const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
            return (
                <span>
                    {parts.map((part, i) =>
                        <span key={i} style={part.toLowerCase() === highlightText.toLowerCase() ? { fontWeight: 'bold' } : {}}>
                            {part}
                        </span>)
                    }
                </span>
            );
        } else {
            return <span></span>;
        }
    }

    const DRListLink = (props: DRLinkType) => {

        function onClickFile() {
            async function markAsRead() {
                const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${sessionInfo.firm.id}/${sessionInfo.user.account}/${props.entry.MsgID}/read?SessionID=${sessionInfo.sid}`;
                    const options = {
                        method: 'PUT',
                        headers: { "Content-Type": "application/json" },
                    }
                    const response = await fetch(url, options);
                    if (response && response.ok) {
                        const resJson = await response.json();
                        return resJson.ok;
                    }
            }
            if (props.entry.Status !== 1) {
                markAsRead();
            }
            switch (props.entry.MsgType) {
                case "1": // vip
                    if (listProps.ModalType === "mortgage" || (listProps.ModalType === "inbox" && props.entry.MatterNumber?.trim() !== "")) {
                        try{
                            const urlParams = new URLSearchParams(window.top.location.search);
                            const component = JSON.parse(urlParams.get("params"))?.component;
                            let appID = null;
                            if(component && component !== 'filelist') {
                                appID = livedataRoot?.getAttribute('AppID')
                            }
                            return nav(VIPDefinitionForMortgageImport(props.entry, appID));
                        } catch(error) {
                            return nav(VIPDefinitionForMortgageImport(props.entry, null));
                        }
                        
                    } else {
                        // dr standalone and rpw inbox (unlinked)
                        return nav(VIPDefinition(props.entry));
                    }
                case "5": // builder
                    if (listProps.ModalType) {
                        if (listProps.ModalType == "infile") {
                            return dispatch(setInboxState(true, {msgID: props.entry.MsgID, directImport: true}));
                        }
                        return dispatch(setInboxState(true, props.entry.MsgID));
                    }
                    return nav(DRDefinition(props.entry.MsgID));
                case "10": // llc, only in rpw
                    debounce(() => {
                        OpenLLCForMortgageImport(props.entry, nav, sessionInfo, listProps.ModalType === "mortgage");
                    }, 500);
                    return;
            }
        }

        const getStatusBadgeProps = (status: string): BadgeProps => {
            switch(status) {
                case "Active":
                    return { bg: "info", text: "light" };
                case "Pending Acceptance":
                    return { bg: "warning", text: "light" };
                case "Cancelled":
                    return { bg: "danger", text: "light" };
                case "New":
                    return { bg: "info", text: "light" };
                case "Completed":
                    return { bg: "success", text: "light" };
                case "Cancellation Requested":
                    return { bg: "danger", text: "light" };
                default:
                    return { bg: "info", text: "dark" };
            }
        };

        return (
            <tr onClick={onClickFile}>
                {listColumns.map(col => {
                    if (col.attrName === "ProjectName") {
                        return (
                            <Fragment key={`${props.entry.MsgID}-${col.attrName}-fragment`}>
                                <td key={`${props.entry.MsgID}-${col.attrName}`}>
                                    {getHighlightedText(props.entry.ProjectName, props.searchText)}
                                </td>
                                <td key={`${props.entry.MsgID}-${col.attrName}-New`}>
                                    {props.entry.Status !== 1 && props.entry.Status !== 3 && props.entry.Status !== 4
                                        && <Badge bg="warning" text="dark" pill>New</Badge>
                                    }
                                </td>
                            </Fragment>
                        )
                    }
                    if (col.attrName === "ReadStatus") {
                        return <td key={`${props.entry.MsgID}-${col.attrName}`}>
                            {props.entry.Status !== 1 && props.entry.Status !== 3 && props.entry.Status !== 4
                                && <Badge bg="warning" text="dark" pill>New</Badge>
                            }</td>
                    }
                    if (col.attrName === "OtherSideType") {
                        return  <td key={`${props.entry.MsgID}-${col.attrName}`}>
                                <Badge bg={props.entry.OtherSideType === "New Home" ? "custom" : "system"} 
                                    text="dark" 
                                    pill>
                                    {props.entry.OtherSideType}
                                </Badge>
                                </td>
                    }
                    if (col.attrName === "AvailableDate") {
                        return <td key={`${props.entry.MsgID}-${col.attrName}`}>
                                <Badge bg="info" text="dark" pill>
                                    {dateStr(props.entry.AvailableDate)}
                                </Badge>
                            </td>
                    }
                    if (col.attrName === "ClientName") {
                        return <td key={`${props.entry.MsgID}-${col.attrName}`}>
                            {getHighlightedText(props.entry.ClientName, props.searchText)}
                        </td>
                    }
                    if (col.attrName === "ClosingDate") {
                        return <td key={`${props.entry.MsgID}-${col.attrName}`}> {props.entry.ClosingDate && 
                                    <Badge bg="secondary" text="dark" pill>
                                        {dateStr(props.entry.ClosingDate)}
                                    </Badge>
                                }
                            </td>
                    }
                    if (col.attrName === "Status") {
                        return <td key={`${props.entry.MsgID}-${col.attrName}`}>
                            <Badge 
                                {...getStatusBadgeProps(getDRMessageStatus(props.entry))}
                                pill
                            >
                                {getDRMessageStatus(props.entry)}
                            </Badge>
                        </td>
                    }
                })}
                <td></td>
            </tr>
        )
    }

    function buildHead (
        columns: FileListColumn[],
        handleClick: (column: string) => void,
        prov: string,
        getSortIcon: (column: string) => JSX.Element
    ) {
        return (
            <tr>
                {columns.map(col => {
                    return (
                        <th key={`th-${col.attrName}`} data-name={col.attrName} onClick={() => { handleClick(col.attrName) }} style={{width: col.width}} colSpan={col.attrName === 'ProjectName' ? 2 : 1}>
                            {getSortIcon(col.attrName)}
                            {col.title}
                        </th>
                    )
                })}
                <th key="options"></th>
            </tr>
        )
    }

    const getFilterCount = () => {
        return Filter.Types?.length + 
               Filter.MortgageStatuses?.length + 
               (Filter.Status ? 1 : 0) + 
               (Filter.Lawyer ? 1 : 0);
    };

    const handleDealCodeSubmit = (dealCode: string) => {
        importDealCode(dealCode, listProps.ModalType, livedataRoot?.getAttribute("AppID"), nav).then(() => {
            setShowDealCodeModal(false);
        }).catch((error) => {
            console.error("Error importing deal code:", error);
            setErrorMessage(error.message);
        });
    };

    return (<div className="file-list">
                <List
                    as={"Card"}
                    listName={listDef[0].listName}
                    handleLoadFileData={handleLoadFileData}
                    FileListColumns={listColumns}
                    buildHead={buildHead}
                    buildListLink={buildDRListLink}
                    dataType={listDef[0].dataType}
                    searchTable={listDef[0].searchTable}
                    buildSearchFilters={buildSearchFilters}
                    staticSearch={staticSearch}
                    ref={searchRef}
                    filterCount={getFilterCount()} 
                    showFilters={showFilters}
                    setShowFilters={setShowFilters}
                    buildButtonRight={buildButtonRight}
                 />
                
                <DealCodeModal
                    show={showDealCodeModal}
                    onClose={() => setShowDealCodeModal(false)}
                    onSubmit={handleDealCodeSubmit}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                />

            </div>
    )
}

function DRDefinition(msgID: number): NavObjectType {
    let navigation: NavObjectType = {
        component: 'main',
        label: "Documents",
        reactFrame: "builderdoc",
        params: {
            'type': 'file',
            'id': msgID.toString(),
        },
    };
    return navigation;
}

function VIPDefinition(data: DRListItem): NavObjectType {
    // open vip in iframe
    const navigation: NavObjectType = {
        component: 'main',
        isModal: true,
        url: `/vip/ShowMsgView.asp`,
        params: {
            'MsgID': String(data.MsgID),
            'viewTab': '5',
            'NoHeader': '1',
            "IsBankMsg": data.MsgType === '10' ? '1' : '0',
            "standalone": "1",
        },
        popup: true,
        popupStyle: 'xlarge',
        redirect: true,
        callback: (_retval: string) => {
            return null;
        }
    };
    return navigation;
}

function VIPDefinitionForMortgageImport(data: DRListItem, appID: string): NavObjectType {
    // open vip in iframe
    const navigation: NavObjectType = {
        component: 'main',
        isModal: true,
        url: `/vip/ShowMsgView.asp`,
        params: {
            'MsgID': String(data.MsgID),
            'viewTab': '5',
            'NoHeader': '1',
            "IsBankMsg": data.MsgType === '10' ? '1' : '0',
            'RPW': '',
            'linked': '1',
            ...(appID ? { 'skipFileSelection': appID } : {})
        },
        popup: true,
        popupStyle: 'xlargelong',
        redirect: true,
        callback: (retval: string) => {
            function importdata() {
                if(data.MsgType == "1" || data.MsgType == "10"){
                    var importVals = retval.split("-");
                    if (retval > "" && importVals && importVals[0] !== 'open' && importVals[1] && importVals[1] !== 'new' && importVals.length < 4){
                        runInnerFunction2("MergeVIPData", [importVals[0], importVals[1], data.MsgType == "1" ? "1" : "0"]);
                        runInnerFunction("SetPageDirty", null);
                    }
                    else if(retval > "" && importVals && importVals[0] === 'copy' && importVals.length === 4 && importVals[1] !== 'new'){
                        const appID = importVals[1];
                        const msgID = importVals[2];
                        const mergeParts = importVals[3];
                        if (appID > "" && msgID > "" && mergeParts > ""){
                            const navObj: NavObjectType = {
                                component: "main",
                                url: "lfmaster.asp",
                                controller: {
                                    tabName: "Basic",
                                    tabNumber: 0,
                                    refresh: true,
                                },
                                params: {
                                    formasp: "purfileedit",
                                    tb: "TPAppXML",
                                    id: appID,
                                    compat: "1",
                                    ReactDocument: "-1",
                                    onload: `MergeVIPData(${msgID},"${mergeParts}",1)`,
                                }
                            }
                            return navObj;
                        }
                    }
                    else if (importVals && importVals[0] === 'open' && importVals[1] > ""){
                        const fileParams: NavObjectType = {
                            component: 'main',
                            url: 'lfmaster.asp',
                            params: {
                                'formasp': 'purfileedit',
                                'tb': 'TPAppXML',
                                'id': importVals[1],
                                'compat': '1',
                                'ReactDocument': '-1'
                            },
                            controller: {
                                tabName: "Basic",
                                tabNumber: 0,
                                refresh: true,
                            },
                        };
                        return fileParams;
                    }
                    else if (importVals && importVals[0] === 'copy' && importVals[1] && importVals[1] === 'new'){
                        let navObj: NavObjectType = null;
                        let appID = importVals[2] ?? '';
                        let mergeParts = importVals[3] ?? '';
                        if (appID > "") {
                            navObj = {
                                component: "main",
                                url: "lfmaster.asp",
                                params: {
                                    formasp: "purfilenew",
                                    src: "NewLiveFormapp.asp",
                                    onload: `MergeVIPData(${appID},"${mergeParts}",1)`,
                                },
                                // init: true,
                            }
                        }
                        return navObj;
                    }
                    else {
                        return null;
                    }
                }
            }
            return importdata();
        }
    };
    return navigation;
}

function OpenLLCForMortgageImport(data: DRListItem, nav: any, sessionInfo: lddGlobalSessionInfo, isMortgageImport: boolean): any {
    try {
        // transNode = runInnerFunction2("LLCFuncs.getTransData", [data.MatterNumber, data.LawyerID]);
        LLCFuncs.getTransData(data.MatterNumber, data.LawyerID).then((transNode) => {
            if (!transNode) {
                // the deal seems to be not available anymore
                var msg = "This deal is no longer available. Do you want to remove it from your inbox?\n"
                msg += "For support, please contact the financial institution associated with this deal."
                var removeConfirm = window.confirm(msg);
                if(removeConfirm) {
                    drRemoveLLCMsg(data.MsgID, sessionInfo.sid);
                } else {
                    LLCFuncs.UpdateStatus(data.MatterNumber, data.LawyerID);
                }
                return;
            }
            
            prepareMsgNodeForLLC(data, transNode, sessionInfo, isMortgageImport).then((MsgNode) => {
                if (MsgNode) {
                    transNode.appendChild(MsgNode);
                }

                const navigation: NavObjectType = {
                    component: 'main',
                    isModal: true,
                    url: "lfpopup.asp",
                    params: {
                        'NoHeader': '1',
                        'diagData': '1',
                        'formxml': 'llcNewTransaction'
                    },
                    windowState: {
                        dialogArguments: {
                            datalockobj: {},
                            liveformPopupDataNode: transNode,
                            location: {}
                        }
                    },
                    popup: true,
                    popupStyle: 'xlarge',
                    redirect: true,
                    callback: (retval: string) => {
                        function importdata() {
                            if(data.MsgType == "1" || data.MsgType == "10"){
                                var importVals = retval.split("-");
                                if (retval > "" && importVals && importVals[0] !== 'open' && importVals[1] && importVals[1] !== 'new' && importVals.length < 4){
                                    runInnerFunction2("MergeVIPData", [importVals[0], importVals[1], data.MsgType == "1" ? "1" : "0"]);
                                    runInnerFunction("SetPageDirty", null);
                                }
                                else if(retval > "" && importVals && importVals[0] === 'copy' && importVals.length === 4 && importVals[1] !== 'new'){
                                    const appID = importVals[1];
                                    const msgID = importVals[2];
                                    const mergeParts = importVals[3];
                                    const msgType = data.MsgType == "1" ? "1" : "0";
                                    if (appID > "" && msgID > "" && mergeParts > ""){
                                        const navObj: NavObjectType = {
                                            component: "main",
                                            url: "lfmaster.asp",
                                            controller: {
                                                tabName: "Basic",
                                                tabNumber: 0,
                                                refresh: true,
                                            },
                                            params: {
                                                formasp: "purfileedit",
                                                tb: "TPAppXML",
                                                id: appID,
                                                compat: "1",
                                                ReactDocument: "-1",
                                                onload: `MergeVIPData(${msgID},"${mergeParts}",${msgType})`,
                                            }
                                        }
                                        return navObj;
                                    }
                                }
                                else if (importVals && importVals[0] === 'open' && importVals[1] > ""){
                                    const fileParams: NavObjectType = {
                                        component: 'main',
                                        url: 'lfmaster.asp',
                                        params: {
                                            'formasp': 'purfileedit',
                                            'tb': 'TPAppXML',
                                            'id': importVals[1],
                                            'compat': '1',
                                            'ReactDocument': '-1'
                                        },
                                        controller: {
                                            tabName: "Basic",
                                            tabNumber: 0,
                                            refresh: true,
                                        },
                                    };
                                    return fileParams;
                                }
                                else if (importVals && importVals[0] === 'copy' && importVals[1] && importVals[1] === 'new'){
                                    let navObj: NavObjectType = null;
                                    let appID = importVals[2] ?? '';
                                    let mergeParts = importVals[3] ?? '';
                                    const msgType = data.MsgType == "1" ? "1" : "0";
                                    if (appID > "") {
                                        navObj = {
                                            component: "main",
                                            url: "lfmaster.asp",
                                            params: {
                                                formasp: "purfilenew",
                                                src: "NewLiveFormapp.asp",
                                                onload: `MergeVIPData(${appID},"${mergeParts}",${msgType})`,
                                            },
                                            // init: true,
                                        }
                                    }
                                    return navObj;
                                }
                                else {
                                    return null;
                                }
                            }
                        }
                        return importdata();
                    }
                };
                return nav(navigation);
            })

            
        })
    } catch (error) {
        console.log(error);
    }
    
}

async function prepareMsgNodeForLLC(data: DRListItem, transNode: ajaxslt.XNode, sessionInfo: lddGlobalSessionInfo, isMortgageImport: boolean) {
    var xmlStr: string = "<Message MsgID=\""+data.MsgID+"\" MsgType=\"" + data.MsgType + "\" IsBankMsg=\"" + (data.MsgType == '1') + "\" Type=\"" + data.MsgType + "\" transactionId=\"" + data.MatterNumber + "\" LSUCID=\"" + data.LawyerID + "\"/>";
    var MsgNode = new ajaxslt.XDocument();
    MsgNode.loadXML(xmlStr);

    // var isNewDeal = false;
    if(data.MsgID > 0) {

        var docMsgRPW = await getLinkedRWFile(String(data.MsgID), sessionInfo);
        if (docMsgRPW && docMsgRPW.AppID) {
            MsgNode.documentElement.setAttribute("linked", "1");
        }
    }

    var province = sessionInfo.appProvinceShort;
    MsgNode.documentElement.setAttribute('appProvince', province);
    if((province > '' && transNode.selectSingleNode('LLCTransaction/properties/address/province').text.toUpperCase() != province) ||
        (transNode.selectSingleNode('LLCTransaction/properties/estateType').text == "LEASEHOLD")) {
            MsgNode.documentElement.setAttribute('notAllowToAction', '1');
    }
    if (isMortgageImport) {
        MsgNode.documentElement.setAttribute("mortgageImport", "1");
    }
    return MsgNode;
}